import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
import { DealConditionsSummary } from './deal-conditions';

DealConditionsSummary;

export type ConditionsRendererParams = ICellRendererParams;

export class ConditionsRenderer implements ICellRenderer {
  private params: ConditionsRendererParams;

  eGui: HTMLElement;

  dealConditions: DealConditionsSummary;

  getGui(): HTMLElement {
    return this.eGui;
  }

  init(params: ConditionsRendererParams): void {
    this.params = params;
    this.render();
  }

  refresh(params: ConditionsRendererParams): boolean {
    this.params = params;
    this.applyParams();
    return true;
  }

  private render(): void {
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.height = '100%';
    this.eGui.style.width = '100%';

    this.dealConditions = document.createElement(
      'deal-conditions-summary',
    ) as DealConditionsSummary;
    this.applyParams();
    this.eGui.append(this.dealConditions);
  }

  private applyParams(): void {
    this.dealConditions.order = this.params.data;
  }
}
